// Shared across every proposal: the marketing plan Adam pays for (replaces the old service levels).
// Edit here once; every client's page picks it up.

export const marketingPlan = {
  callout: "I pay for the first 45 days of staging, at closing.",
  groups: [
    {
      key: "pre",
      title: "Pre-listing",
      items: ["White Glove Listing Manager", "Advice and time prior to listing", "Vendor advice and coordination"],
    },
    {
      key: "marketing",
      title: "Marketing",
      items: [
        "Professional twilight photography",
        "3D Matterport tour",
        "High-end video",
        "Website",
        "Listing sign",
        "Online MLS listing",
        "Redfin and Zillow major portal syndication",
        "Online paid advertising",
        "Open houses weekly: 2 the first weekend, then 1 every other weekend",
        "Home staging (if vacant or needed): first 45 days paid by me at closing",
      ],
    },
    {
      key: "management",
      title: "Listing management",
      items: [
        "Every showing followed up",
        "Daily feedback for the first week",
        "Weekly marketing and feedback report",
        "Home security checks (if needed)",
        "Ongoing market analysis",
        "Ongoing pricing analysis",
        "Expert offer negotiation",
        "Contract-to-close manager",
        "Post-close support",
      ],
    },
    {
      key: "luxury",
      title: "Luxury home marketing",
      condition: "Top 5% of local price point",
      items: [
        "Upgraded flyers",
        "Foam board countertop display",
        "The Wall Street Journal",
        "Robb Report",
        "Unique Homes",
        "Mansion Global",
        "UPMKT",
        "Luxury Estate",
        "Barron's",
        "MarketWatch",
        "International marketing syndication to 90 prominent search sites",
      ],
    },
  ],
  footnote: "Home preparation is paid by you and coordinated by my team. See Getting your home ready.",
};
